import React, { useState, useEffect } from "react";

//outsource
import { Row, Input, Modal, Button, Space, message } from "antd";

//components
import { useDispatch, useSelector } from "react-redux";
import { setOpenGroupAdd } from "../../../store/var/var.action";
import { openAddGroup } from "../../../store/var/var.selector";
import { addGroup } from "../../../store/group_service/group.action";
import { detailSelector } from "../../../store/branch/branch.selector";

const DialogGroupAdd = () => {
  // -------------------------- VAR --------------------------
  const title = `Add a Group`;

  // -------------------------- STATE --------------------------
  const [group, setGroup] = useState("");
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(openAddGroup);
  const branch = useSelector(detailSelector);

  // -------------------------- FUNCTION -----------------------
  const closeOpenDialog = () => {
    dispatch(setOpenGroupAdd({ data: false }));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setGroup(value);
  };

  const handleAdd = () => {
    if (branch && group !== "") {
      setLoading(true);
      dispatch(
        addGroup({ group, branch: branch?.id }, (res) => {
          setLoading(false);
          if (res.status === 200) {
            message.success("Added Successfully!");
            closeOpenDialog();
            setGroup("");
          } else {
            message.error(res.data);
          }
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  const renderModalBody = () => {
    return (
      <Row>
        <Input placeholder="Group Name..." onChange={handleChange} />
      </Row>
    );
  };

  const renderFooter = () => {
    const disabled = group === "" || false;
    return (
      <Space>
        <Button type="default" onClick={closeOpenDialog}>
          Cancel
        </Button>
        <Button
          type="primary"
          className={disabled ? "disabled-btn" : "green"}
          disabled={disabled}
          onClick={handleAdd}
          loading={loading}
        >
          Add
        </Button>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title={title}
      open={open}
      onCancel={closeOpenDialog}
      footer={renderFooter()}
    >
      {renderModalBody()}
    </Modal>
  );
};

export default DialogGroupAdd;
